import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../core/store/store';

// Core
import { appConfig } from '../../config/app-config';
import { ErrorMessage } from '../../core/model/error-message';

// Own feature
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { IChecker, NavigationService } from '../../nav/service/navigation.service';
import { UserService } from '../../user/service/user.service';
import { DtbSelectPopupComponent } from '../dtb-select-popup/dtb-select-popup.component';
import { FgSelectPopupComponent } from '../fg-select-popup/fg-select-popup.component';

@Component({
   selector: 'app-topmenu',
   templateUrl: './topmenu.component.html',
   styleUrls: ['./topmenu.component.scss']
})
export class TopmenuComponent implements OnInit {

   public backendVersion = '';
   public checkers: IChecker[];

   @select((s: IAppState) => s.userState.currentUser) user$;

   constructor(
      private _router: Router,
      private _store: NgRedux<IAppState>,
      private _userService: UserService,
      private _navService: NavigationService,
      private _datePipe: DatePipe,
      private dialog: MatDialog,
   ) {
   }

   ngOnInit() {
      this.initChecker();
   }

   // -- Status -----------------------------------------------------------------------------------
   public showLoginCmds(): boolean {
      return !this.isLoggedIn();
   }
   public showLoggedInCmds(): boolean {
      return this.isLoggedIn();
   }

   public showReportsDownload(): boolean {
      return this.isLoggedIn();
   }

   public isLoggedIn(): boolean {
      return this._userService.isUserSignedIn();
   }
   public showDebugCmds(): boolean {
      return appConfig.dev.debugMode;
   }

   public getVersionFrontend(): string {
      if (appConfig.dev.debugMode) {
         return appConfig.app.versionSoft;
      } else {
         return '';
      }
   }

   public getVersionBackend(): string {
      return this._store.getState().userState.backendVersion;
   }

   public navigatePasswordChangeCard() {
      this._router.navigate(['/password']);
   }

   // ---------------------------------------------------------------------------------------------
   // -- Command Handler
   // ---------------------------------------------------------------------------------------------
   public onLogout(): void {

      this._userService.signOut()
         .catch((msg: ErrorMessage) => {
            console.warn(msg.message);
         });

      this._router.navigate(['/signin']);
   }

   public onDebugDumpStore(): void {
      console.log(this._store.getState());
   }

   public initChecker() {
      if (!this.checkers || !this.checkers.length) {
         this._navService.getCheckers().then((checkers) => this.checkers = checkers).catch((err) => console.log(err));
      }
   }

   public onCheckerClick(id: string) {
      const checker = this.checkers.find((v) => v.id == id);
      const name = checker ? checker.name : id;
      this._navService.getReport(id).then(
         (res) => {
            this.downloadBlob(name, res.body);
         },
      ).catch((err) => {
         var blob: Blob;
         if (!err.errorObject || !err.errorObject.error) {
            blob = new Blob([err.message], { type: "text/html" });
         } else if (typeof err.errorObject.error == "string") {
            blob = new Blob([err.errorObject.error], { type: "text/html" });
         } else {
            blob = err.errorObject.error;
         }
         this.downloadBlob(name, blob);
      });
   }

   public downloadBlob(name: string, blob: Blob) {
      const date = Date.now();
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      let ending: String;
      switch (blob.type) {
         case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            ending = "xlsx";
            break;
         case "text/html":
            ending = "txt";
            break;
         case "application/zip":
            ending = "zip";
            break;
         default:
            ending = "txt";
            break;
      }
      a.download = `${this._datePipe.transform(date, 'yyyy-MM-dd_hh-mm-ss')}_${name}.${ending}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
   }

   public onChecklistClick() {
      this.dialog.open(DtbSelectPopupComponent, {
         height: '80%',
         width: '80%',
      });
   }

   public onChecklistFGClick() {
      this.dialog.open(FgSelectPopupComponent, {
         height: '80%',
         width: '80%',
      });
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/menu/topmenu/topmenu.component.ts